import React from 'react';
import i18n from "../../../i18next";
import { Container, Row, Col, Button, FormGroup, Label, Input } from 'reactstrap';
import MaterialIcon from 'material-icons-react';

class CustomerInsightSearchOptions extends React.Component {

    state = {
        requestRangeSelection: requestRange.LIFETIME,
        customOptionEnabled: false,
        fromDate: '',
        toDate: '',
        customStartDate: '',
        customEndDate: ''
    }

    changeRangeOptions = rangeOption => {

        if (this.state.requestRangeSelection === rangeOption) {
            if (rangeOption === requestRange.CUSTOM) {
                this.setState({ customOptionEnabled: !this.state.customOptionEnabled })
                return;
            }
            return;
        }

        const startDate = this.formStartDate(rangeOption);
        const endDate = this.formEndDate(rangeOption);

        this.setState({
            requestRangeSelection: rangeOption,
            customOptionEnabled: rangeOption === requestRange.CUSTOM ? true : false,
            fromDate: rangeOption === requestRange.CUSTOM ? this.state.fromDate : startDate,
            toDate: rangeOption === requestRange.CUSTOM ? this.state.fromDate : endDate
        })

        if (this.isModalWithoutSearchButton()) {

            if (rangeOption !== requestRange.CUSTOM) {
                this.props.takeSearchOptionState({ fromDate: startDate, toDate: endDate })
            }
        }
    }

    isModalWithoutSearchButton = () => {
        if (this.props.type === "OrderTypes" ||
            this.props.type === "PaymentTypes" ||
            this.props.type === "SourceTypes" ||
            this.props.type === "OrderFrequency") {
            return true
        }
        return false;
    }

    formStartDate = rangeOption => {

        const date = new Date();

        switch (rangeOption) {
            case requestRange.LIFETIME: return null;
            case requestRange.CUSTOM: return;
            case requestRange.TODAY: {
                const days = date.getDate().toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
                const months = (date.getMonth() + 1).toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
                return `${days}-${months}-${date.getFullYear()}`
            }
            case requestRange.LAST_WEEK: {
                date.setDate(date.getDate() - 7);
                const days = date.getDate().toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
                const months = (date.getMonth() + 1).toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
                return `${days}-${months}-${date.getFullYear()}`
            }
            case requestRange.LAST_MONTH: {
                date.setMonth(date.getMonth() - 1);
                const days = date.getDate().toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
                const months = (date.getMonth() + 1).toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
                return `${days}-${months}-${date.getFullYear()}`
            }
            case requestRange.LAST_THREE_MONTHS: {
                date.setMonth(date.getMonth() - 3);
                const days = date.getDate().toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
                const months = (date.getMonth() + 1).toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
                return `${days}-${months}-${date.getFullYear()}`
            }
            case requestRange.LAST_SIX_MONTHS: {
                date.setMonth(date.getMonth() - 6);
                const days = date.getDate().toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
                const months = (date.getMonth() + 1).toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
                return `${days}-${months}-${date.getFullYear()}`
            }
            case requestRange.LAST_YEAR: {
                date.setFullYear(date.getFullYear() - 1);
                const days = date.getDate().toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
                const months = (date.getMonth() + 1).toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
                return `${days}-${months}-${date.getFullYear()}`
            }
            default: return;
        }

    }

    formEndDate = rangeOption => {
        switch (rangeOption) {
            case requestRange.LIFETIME: return null;
            case requestRange.CUSTOM: return;
            default: {
                const date = new Date();
                const days = date.getDate().toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
                const months = (date.getMonth() + 1).toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
                return `${days}-${months}-${date.getFullYear()}`
            }
        }
    }

    setCustomTimeRange = () => {
        const startDateArr = this.state.customStartDate.split('-');
        const endDateArr = this.state.customEndDate.split('-');

        const formattedStartDate = `${startDateArr[2]}-${startDateArr[1]}-${startDateArr[0]}`;
        const formattedEndDate = `${endDateArr[2]}-${endDateArr[1]}-${endDateArr[0]}`;

        this.setState({
            //customOptionEnabled: false,
            fromDate: formattedStartDate,
            toDate: formattedEndDate
        })

        this.props.takeSearchOptionState({ fromDate: formattedStartDate, toDate: formattedEndDate })
    }

    renderTimeOptions = () => {

        const { rangeTextOption, underline } = styles;

        return (
            <Col xs={7} sm={7} style={{ display: 'flex', alignItems: 'center', paddingLeft: 0 }} >
                <span
                    style={(this.state.requestRangeSelection === requestRange.LIFETIME) ? { ...rangeTextOption, ...underline } : rangeTextOption}
                    onClick={() => this.changeRangeOptions(requestRange.LIFETIME)}>{i18n.t('screens:customerInsightScreen.lifetime')}</span>
                <span
                    style={(this.state.requestRangeSelection === requestRange.TODAY) ? { ...rangeTextOption, ...underline } : rangeTextOption}
                    onClick={() => this.changeRangeOptions(requestRange.TODAY)}>{i18n.t('screens:customerInsightScreen.today')}</span>
                <span
                    style={(this.state.requestRangeSelection === requestRange.LAST_WEEK) ? { ...rangeTextOption, ...underline } : rangeTextOption}
                    onClick={() => this.changeRangeOptions(requestRange.LAST_WEEK)}>{i18n.t('screens:customerInsightScreen.oneWeek')}</span>
                <span
                    style={(this.state.requestRangeSelection === requestRange.LAST_MONTH) ? { ...rangeTextOption, ...underline } : rangeTextOption}
                    onClick={() => this.changeRangeOptions(requestRange.LAST_MONTH)}>{i18n.t('screens:customerInsightScreen.oneMonth')}</span>
                <span
                    style={(this.state.requestRangeSelection === requestRange.LAST_THREE_MONTHS) ? { ...rangeTextOption, ...underline } : rangeTextOption}
                    onClick={() => this.changeRangeOptions(requestRange.LAST_THREE_MONTHS)}>{i18n.t('screens:customerInsightScreen.threeMonths')}</span>
                <span
                    style={(this.state.requestRangeSelection === requestRange.LAST_SIX_MONTHS) ? { ...rangeTextOption, ...underline } : rangeTextOption}
                    onClick={() => this.changeRangeOptions(requestRange.LAST_SIX_MONTHS)}>{i18n.t('screens:customerInsightScreen.sixMonths')}</span>
                <span
                    style={(this.state.requestRangeSelection === requestRange.LAST_YEAR) ? { ...rangeTextOption, ...underline } : rangeTextOption}
                    onClick={() => this.changeRangeOptions(requestRange.LAST_YEAR)}>{i18n.t('screens:customerInsightScreen.oneYear')}</span>
                <span
                    style={(this.state.requestRangeSelection === requestRange.CUSTOM) ? { ...rangeTextOption, ...underline } : rangeTextOption}
                    onClick={() => this.changeRangeOptions(requestRange.CUSTOM)}>{i18n.t('screens:customerInsightScreen.custom')}</span>
            </Col>
        );
    }

    renderSubmitButton = () => {
        return (
            <Col xs={5} sm={5} style={{ display: 'flex', justifyContent: 'flex-end', paddingRight: 0 }}>
                {this.renderButton()}
            </Col>
        );
    }

    renderButton = () => {
        if (this.isModalWithoutSearchButton()) {
            return null;
        }

        if (this.state.requestRangeSelection !== requestRange.CUSTOM) {
            return (
                <Button
                    color='primary'
                    style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginRight: 6 }}
                    onClick={() => this.props.takeSearchOptionState(this.state)}
                >
                    <MaterialIcon icon="search" color="#fff" size={19} />
                    <div style={{ marginLeft: 5 }}>{i18n.t('screens:customerInsightScreen.search')}</div>
                </Button>
            );
        }

        return (
            <Button
                color='primary'
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginRight: 6 }}
                onClick={this.setCustomTimeRange}
                disabled={!(this.state.customStartDate && this.state.customEndDate) || (this.state.customStartDate > this.state.customEndDate)}
            >
                <MaterialIcon icon="search" color="#fff" size={19} />
                <div style={{ marginLeft: 5 }}>{i18n.t('screens:customerInsightScreen.search')}</div>
            </Button>
        );

    }

    renderCustomOptions = () => {

        const { rowBottom, fromDatePickerLabel, toDatePickerLabel } = styles;

        if (!this.state.customOptionEnabled) {
            return null;
        }

        return (
            <Row style={rowBottom}>
                <Col xs={8} sm={8} >
                    <Row>
                        <Col sm={5}>
                            <FormGroup row>
                                <Label for="startDate" style={fromDatePickerLabel}
                                    sm={3}>{i18n.t('screens:promotionValidityScreen.datePickerFrom')}</Label>
                                <Col sm={9}>
                                    <Input
                                        type="date"
                                        name="startDate"
                                        id="startDate"
                                        placeholder="datetime placeholder"
                                        value={this.state.customStartDate}
                                        onChange={(e) => this.setState({ customStartDate: e.target.value })}
                                    />
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col sm={5}>
                            <FormGroup row>
                                <Label for="endDate" style={toDatePickerLabel}
                                    sm={3}>{i18n.t('screens:promotionValidityScreen.datePickerTo')}</Label>
                                <Col sm={9}>
                                    <Input
                                        type="date"
                                        name="endDate"
                                        id="endDate"
                                        placeholder="datetime placeholder"
                                        value={this.state.customEndDate}
                                        onChange={(e) => this.setState({ customEndDate: e.target.value })}
                                    />
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col sm={2}>
                            {
                                this.isModalWithoutSearchButton() ?
                                    <Button
                                        color='primary'
                                        onClick={this.setCustomTimeRange}
                                        disabled={!(this.state.customStartDate && this.state.customEndDate) || (this.state.customStartDate > this.state.customEndDate)}
                                    >{i18n.t('screens:reportsScreen.common.confirmButton')}
                                    </Button>
                                    : null
                            }
                        </Col>
                    </Row>
                </Col>
            </Row>
        );
    }

    render() {

        const { rowBottom } = styles;

        return (
            <Container fluid>
                <Row style={rowBottom}>
                    {this.renderTimeOptions()}
                    {this.renderSubmitButton()}
                </Row>
                {this.renderCustomOptions()}
            </Container>
        );
    }
}

export default CustomerInsightSearchOptions;

const requestRange = {
    "LIFETIME": 1,
    "TODAY": 2,
    "LAST_WEEK": 3,
    "LAST_MONTH": 4,
    "LAST_THREE_MONTHS": 5,
    "LAST_SIX_MONTHS": 6,
    "LAST_YEAR": 7,
    "CUSTOM": 8
};

const styles = {
    rangeTextOption: {
        marginRight: 20,
        color: '#0288D1',
        cursor: 'pointer',
        fontSize: 14
    },
    underline: {
        textDecoration: 'underline'
    },
    rowBottom: {
        paddingBottom: '20px'
    },
    fromDatePickerLabel: {
        position: 'relative',
        top: 5
    },
    toDatePickerLabel: {
        position: 'relative',
        top: 5
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/customerInsightScreen/CustomerInsightSearchOptions.js